import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
//active menu
import { activeMenu,logout } from '../../../../../reducer/userReducer';
import { useDispatch,useSelector } from 'react-redux';
//chat mdb-react-ui-kit
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
  MDBIcon,
  MDBCardFooter,
  MDBSpinner,
} from "mdb-react-ui-kit";

import Messages from './message'

import axios from 'axios';
const Groq = () => {

    const { userStorage } = useSelector((state) => ({ ...state }))
    const name = userStorage.user.name;
    const profile = userStorage.user.image;

    const authtoken = localStorage.getItem('token')
   
    const [messages,setMessages] = useState([{ message: "Hello, I am Groq!", sender: "Groq", direction: "incoming" }]);
    const [message,setMessage] = useState("");
    const [typing,setTyping] = useState(false);
    //active menu
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const activePath = "Groq";

    //สร้าง Ref สำหรับจุดล่างสุดของแชท
    const messagesEndRef = useRef(null);
    //ฟังก์ชันสำหรับสั่งให้เลื่อนลงล่างสุด
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        dispatch(activeMenu(activePath));
        scrollToBottom();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[dispatch,messages]);
    //active menu

    const handleSend = async () => {
      const newMessage = {
        message: message,
        sender: "user",
        direction: "outgoing"
      }
      if (message.trim() !== "") {
      const newMessages = [...messages, newMessage] //all the old messages, + new message

      //update our message state
      setMessages(newMessages);

      //set a typing indicator (Groq is typing)
      setTyping(true);
      setMessage("");
      //process message to Groq
      await processMessageToGroq(newMessages);
      }
    }

    async function processMessageToGroq(chatMessages) {
      
      let apiMessages = chatMessages.map((messageObject) =>{
        let role = "";
        if(messageObject.sender === "Groq"){
          role="assistant";
        }else{
          role = "user";
        }
        return {role: role, content: messageObject.message}
      });

      const systemMessage = {
        role: "system",
        content: "Explain all concepts like I am 10 years old."
      }

      const apiRequestBody = {
        "model": "llama-3.1-8b-instant",
        "messages": [
          systemMessage,
          ...apiMessages
        ]
      }

        axios.post(process.env.REACT_APP_API+'/groq',
        {apiRequestBody},
        {
            headers:{ authtoken }
        }
        ).then((data) =>{
          return data;
        }).then((res) => {
          setMessages([
            ...chatMessages, {
              message: res.data.choices[0].message.content,
              sender: "Groq",
              direction: "incoming"
            }
          ])
          setTyping(false);
        }).catch(err => {
          dispatch(logout())
          navigate("/");
          console.log(err)
        });

    }

    const handleKeyDown = (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault(); // ป้องกันขึ้นบรรทัดใหม่ใน input
        handleSend();
      }
    };

    return (
      <MDBContainer className="py-0" >
        <MDBRow className="d-flex justify-content-center">
          <MDBCol md="8" lg="6" xl="4" style={{textAlign:'center',width:'100%'}}>
            <MDBCard id="chat1" style={{ height: "70vh",borderRadius: "15px" }}>
              <MDBCardHeader
                className="d-flex justify-content-between align-items-center p-3 text-white border-bottom-0"
                style={{
                  borderTopLeftRadius: "15px",
                  borderTopRightRadius: "15px",
                   backgroundColor: '#fd7e14',
                }}
              >
                <p className="mb-0 fw-bold" style={{textAlign:'center',width:'100%'}}>Groq</p>
              </MDBCardHeader>
  
              <MDBCardBody style={{ overflowY: 'auto' }}>

                {messages.map((massagess, i) => {
                 return <Messages key={i} msg={massagess} profile={profile} name={name} />
                })}
              <div ref={messagesEndRef} />
              </MDBCardBody>
              {typing 
              ?<MDBSpinner grow style={{ width: '100%', height: '0.1rem' }} className='ms-1' color='blue' >
                <span className='visually-hidden'>Loading...</span>
              </MDBSpinner> 
              : null
              }
              <MDBCardFooter className="text-muted d-flex justify-content-start align-items-center p-3">
                <input
                  type="text"
                  className="form-control shadow-none"
                  id="exampleFormControlInput3"
                  placeholder="Type message"
                  value={message}
                  onChange = { e => setMessage(e.target.value)}
                  onKeyDown={handleKeyDown} // ตรวจจับ Enter เท่านั้น
                  style={{
                    border: '0px solid #ccc',
                    padding: '10px',
                    borderRadius: '50px',
                    outline: 'none', // ทำให้ไม่มีขอบเมื่อตั้งโฟกัส
                  }}
                />
                <a className="ms-3 link-info" href="#!" onClick={e => handleSend(e)}>
                  <MDBIcon fas icon="paper-plane" />
                </a>
              </MDBCardFooter>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    );
}

export default Groq